import { useEffect } from "react";
import { getBirthHistory } from "../../../apiHandler/actions/profile";
import { Skeleton } from "@material-ui/lab";

const Component = (props) => {
  const { birthHistory, setBirthHistory } = props;

  useEffect(() => {
    if (birthHistory === null) fetchAllergies();
    // eslint-disable-next-line
  }, []);

  const fetchAllergies = async () => {
    const response = await getBirthHistory(props.uuid);
    if (response.birthHistory) {
      const {
        height,
        weight,
        delivery,
        intialFeeding,
        dichargeInfo,
        additionalInfo,
      } = response.birthHistory;
      setBirthHistory({
        height,
        weight,
        delivery,
        intialFeeding,
        dichargeInfo,
        additionalInfo,
      });
    } else
      setBirthHistory({
        height: "",
        weight: "",
        delivery: "",
        intialFeeding: "",
        dichargeInfo: "",
        additionalInfo: "",
      });
  };

  return (
    <div className="mj-container">
      <table className="mj-bh-table">
        <thead>
          <tr className="mj-bh-title">
            <th>Height</th>
            <th>Weight</th>
            <th>Delivery</th>
            <th>Initial Feeding</th>
            <th>Discharge Time</th>
          </tr>
        </thead>
        {birthHistory === null ? (
          <tbody className="mj-bh-tbody">
            <tr className="mj-bh-value">
              <td>
                <Skeleton variant="text" />
              </td>
              <td>
                <Skeleton variant="text" />
              </td>
              <td>
                <Skeleton variant="text" />
              </td>
              <td>
                <Skeleton variant="text" />
              </td>
              <td>
                <Skeleton variant="text" />
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody className="mj-bh-tbody">
            <tr className="mj-bh-value">
              <td>{birthHistory.height || "N/A"}</td>
              <td>{birthHistory.weight || "N/A"}</td>
              <td>{birthHistory.delivery || "N/A"}</td>
              <td>{birthHistory.intialFeeding || "N/A"}</td>
              <td>{birthHistory.dichargeInfo || "N/A"}</td>
            </tr>
          </tbody>
        )}
      </table>
      {birthHistory && (
        <p className="mj-bh-info">
          <span className="mj-bh-title">Additional Info:</span>{" "}
          <span className="mj-bh-value">
            {birthHistory.additionalInfo || "N/A"}
          </span>
        </p>
      )}
    </div>
  );
};

export default Component;
